module.exports = __webpack_public_path__ + "img/tab-info-hover.4563f825.svg";